export default {
  all: {
    en: 'all',
  },

  lip: {
    en: 'Lip',
  },
  lipBalm: {
    en: 'Lip Balms & Treatments',
  },

  eye: {
    en: 'Eye',
  },
  eyeMasks: {
    en: 'Eye Masks',
  },
  eyeCreamsTreatments: {
    en: 'Eye Creams & Treatments',
  },
  cleansers: {
    en: 'Cleansers',
  },
  faceWash: {
    en: 'Face Wash & Cleansers',
  },
  faceWipes: {
    en: 'Face Wipes',
  },
  exfoliators: {
    en: 'Exfoliators',
  },
  toner: {
    en: 'Toners',
  },
  makeupRemover: {
    en: 'Makeup Remover',
  },

  masks: {
    en: 'Masks',
  },
  faceMask: {
    en: 'Face Masks',
  },
  sheetMask: {
    en: 'Sheet Masks',
  },

  moisturizers: {
    en: 'Moisturizers',
  },
  mists: {
    en: 'Mists',
  },
  faceOil: {
    en: 'Face Oils',
  },
  faceMoisturizer: {
    en: 'Face Moisturizers',
  },

  treatments: {
    en: 'Treatments',
  },
  serum: {
    en: 'Serum',
  },
  blemishAcneSolutions: {
    en: 'Blemish & Acne Solutions',
  },
  ampoules: {
    en: 'Ampoules',
  },

  mens: {
    en: 'Men\'s',
  },
  menFace: {
    en: 'Face',
  },
  menEye: {
    en: 'Eye',
  },
  menShaving: {
    en: 'Shaving',
  },

  wellness: {
    en: 'Wellness',
  },
  calmSootheSleep: {
    en: 'Calm, Soothe & Sleep',
  },
  energyUpgrade: {
    en: 'Energy Upgrade',
  },
  gutHealth: {
    en: 'Gut Health',
  },
  hairSkinNail: {
    en: 'Hair, Skin & Nails',
  },
  immuneSupport: {
    en: 'Immune Support',
  },
  womensHealth: {
    en: 'Women\'s Health',
  },
  workout: {
    en: 'Workout',
  },
}
